let wrappedPlay: typeof HTMLVideoElement.prototype.play | null = null;

/**
 * Sentry plays the screen-capture stream on a video that never enters the document.
 * Edge still resolves that play(). Brave rejects it with AbortError
 * "The play() request was interrupted because the media was removed from the document."
 * Keep the element in the document until play() settles so Brave can grab a frame.
 */
export function keepCaptureVideoInDocument(): void {
  const current = HTMLVideoElement.prototype.play;
  if (current === wrappedPlay) {
    return;
  }
  const play = current;
  wrappedPlay = function (this: HTMLVideoElement): Promise<void> {
    if (
      this.isConnected ||
      typeof MediaStream === 'undefined' ||
      !(this.srcObject instanceof MediaStream)
    ) {
      return play.call(this);
    }
    this.muted = true;
    this.playsInline = true;
    this.setAttribute('aria-hidden', 'true');
    this.style.position = 'fixed';
    this.style.left = '-10000px';
    this.style.width = '1px';
    this.style.height = '1px';
    this.style.pointerEvents = 'none';
    document.body.append(this);
    return play.call(this).finally(() => {
      this.remove();
    });
  };
  HTMLVideoElement.prototype.play = wrappedPlay;
}
